<template>
    <section class="tables landing-page">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Module {{ $route.params.id }} Packing List</h4>
                    </div>
                    <div class="card-body">
                        <form action="" @submit.prevent="" method="post">
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <div role="group" class="form-group">
                                        <div>
                                            <input id="search" name="search" v-model.trim="searchIndex.search" type="text"
                                                placeholder="Search" @keypress.enter="searchFn" class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 form-group">
                                    <input type="button" @click="searchFn" class="btn btn-sm btn-primary" value="search">
                                    <input type="button" @click="exportToPDF" class="btn btn-sm btn-primary ml-2"
                                        value="PDF">
                                </div>
                            </div>
                        </form>
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            :totalRows="tableConfig.totalRecords" :isLoading.sync="tableConfig.isLoading"
                            :pagination-options="tableConfig.options" :rows="packingList" :sort-options="{
                                enabled: false,
                            }" :columns="tableConfig.columns">
                             <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'fileName'">
                                    <span>{{ props.row.ItemName }} {{ props.row.Description }}</span>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>

        </div>
        <div class="p-1 d-none">
            <table class="table" id="exportToPDF">
                <caption class="text-center bold" style="caption-side:top">
                    <h3>Admin Systems | Module {{ moduleNumber }}</h3>
                </caption>
                <caption class="border-top border-dark mt-4 " style="caption-side:bottom">{{ todayDate }}</caption>
                <thead class=" table-dark">
                    <tr>
                        <th scope="col">Quantity</th>
                        <th scope="col">Item</th>
                        <th scope="col">Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in itemPdfData" :key="index">
                        <th scope="row">{{ item.Quantity }}</th>
                        <td>{{ item.ItemName }}</td>
                        <td>{{ item.Description }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>

import Vue from "vue";
import API from "@/api";
import jsPDF from 'jspdf';
import router from '../router';
import moment from 'moment';
import 'jspdf-autotable';
import CircleLoader from '@/pages/loaders/CircleLoader.vue';
Vue.use(jsPDF)

export default {
    data() {
        return {
             isLoading: false,
            moduleNumber: '',
            itemPdfData: [],
            todayDate: "",
            searchIndex: {
                search: "",
                GroupID: 1,
                moduleName: '',
                page: 1, // what page I want to show
                perPage: 10
            },
            packingList: [],
            tableConfig: {
                columns: [
                    {
                        label: 'Qty',
                        field: 'Quantity',
                        type: 'number',
                    },
                    {
                        label: 'Item',
                        field: 'ItemName',
                        type: 'text',
                    },
                    {
                        label: 'Description',
                        field: "Description",
                        type: 'text',
                    }

                ],
                options: {
                    enabled: true,
                    dropdownAllowAll: false,
                    perPageDropdown: [10, 20, 50, 100, 200],
                },
                totalRecords: 0,
                isLoading: false
            }
        }
    },
    methods: {
        exportToPDF() {
            this.allPackingItemsByModulePdf();
            this.todayDateFn()
        },
        // pdfConvert() {
        //     let elementHTML = document.getElementById('exportToPDF');
        //     const doc = new jsPDF()
        //     let self = this;
        //     doc.html(elementHTML, {
        //         callback: function (doc) {
        //             doc.save("module-" + self.moduleNumber + '.pdf');
        //         },
        //         margin: [10, 10, 10, 10],
        //         autoPaging: 'text',
        //         x: 0,
        //         y: 0,
        //         width: 190,
        //         windowWidth: 675
        //     });
        // },
        pdfConvert() {
            const elementHTML = document.getElementById('exportToPDF');
            const tableData = this.packingList.map(row => {
                const rowData = {};
                this.tableConfig.columns.forEach(column => {
                if (column.field === 'fileName') {
                    rowData[column.label] = `${row.ItemName} ${row.user.Description}`;
                } else {
                    rowData[column.label] = row[column.field];
                }
                });
                return rowData;
            });

            const doc = new jsPDF();
            const startY = 15; 
            const tableHeight = doc.autoTable.previous.finalY - startY;
            const textHeight = doc.getTextDimensions(this.todayDate).h;
            const lineHeight = doc.getLineHeight();
            const requiredHeight = tableHeight + textHeight + lineHeight;

            if (requiredHeight > doc.internal.pageSize.getHeight()) {
                doc.addPage();
            }
            doc.autoTable({
                startY: startY,
                columns: this.tableConfig.columns.map(column => ({ header: column.label, dataKey: column.label })),
                body: tableData,
            });
            doc.setFontSize(20);
            doc.text(`Admin Systems | Module ${this.moduleNumber}`, 70, 10);
            doc.setFontSize(8);
            doc.text(this.todayDate, 15, doc.autoTable.previous.finalY + lineHeight * 0.5);
            doc.save(`Module ${this.moduleNumber}`);
        },
        todayDateFn() {
            this.todayDate = moment().format('dddd, MMMM DD YYYY');
        },
        allPackingItemsByModulePdf() {
            API.allPackingItemsByModulePdf(this.searchIndex, this.allPackingItemsByModulePdfCB, this.errorCB)
        },
        allPackingItemsByModulePdfCB(res) {
            this.itemPdfData = res.data;
            setTimeout(() => {
                this.pdfConvert()
            }, 1000)
        },
        searchFn() {
            if (this.searchIndex.search != "") {
                this.allPackingItemsByModule();
            }
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.allPackingItemsByModule();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.allPackingItemsByModule();
        },
        updateParams(newProps) {
            this.searchIndex = Object.assign({}, this.searchIndex, newProps);
        },
        allPackingItemsByModule() {
            let falg = true;
            this.isLoading = true;
            if (this.$route.params.id == 1) {
                this.searchIndex.moduleName = 'Marketing'
            }
            else if (this.$route.params.id == 2) {
                this.searchIndex.moduleName = 'NewPatients'
            }
            else if (this.$route.params.id == 3) {
                this.searchIndex.moduleName = 'Conversion'
            }
            else if (this.$route.params.id == 4) {
                this.searchIndex.moduleName = 'Retention'
            }
            else if (this.$route.params.id == 5) {
                this.searchIndex.moduleName = 'Revenue'
            }
            else if (this.$route.params.id == 6) {
                this.searchIndex.moduleName = 'TeamDevelopment'
            } else {
                falg = false;
                router.push({ path: "/AdminSystem/view_seminar/", name: "view_seminar" });
            }

            if (falg == true) {
                API.allPackingItemsByModule(this.searchIndex, this.allPackingItemsByModuleCB, this.errorCB)
            }
            this.isLoading = false;
        },
        allPackingItemsByModuleCB(res) {
            this.tableConfig.totalRecords = res.data.total;
            this.packingList = res.data.data
            this.moduleNumber = this.$route.params.id;
   this.isLoading = false; 
        },

        deletePackingItems(id) {
            API.deletePackingItems({ id }, this.deletePackingItemsCB, this.errorCB)
        },
        deletePackingItemsCB(res) {
            this.allPackingItemsByModule();
            this.$showNotification(res,"success")
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({message:'Failed system error'},"error")
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.searchIndex.search = '';
        next();
        this.allPackingItemsByModule();
    },
    mounted() {
        this.isLoading = true;
        this.allPackingItemsByModule()
    },
    components: {}
}

</script>